<template>
  <b-modal
    id="modal-lesson-result-detail"
    size="xl"
    scrollable
    hide-footer
    :title="item ? `Kết quả học bài - ${item.fullName || ''}` : ''"
    @show="loadData"
    @hidden="rows = []"
  >
    <div v-if="item" class="mb-4">
      <span class="mr-6">SĐT: {{ phone }}</span>
      <span>Nhóm: {{ item.class || '-' }}</span>
    </div>

    <div v-if="!loading && !rows.length" class="text-center text-muted py-6">
      Chưa học bài nào
    </div>

    <table v-else class="table table-bordered mb-0">
      <thead>
        <tr>
          <th style="width: 60px" class="text-center">STT</th>
          <th>Bài học</th>
          <th style="width: 130px">Mã bài</th>
          <th style="width: 20%">Module</th>
          <th style="width: 70px" class="text-center">Tuần</th>
          <th style="width: 160px">Ngày học</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index) in rows" :key="row.lessonId">
          <td class="text-center">{{ index + 1 }}</td>
          <td>{{ row.lesson }}</td>
          <td>{{ row.lessonCode }}</td>
          <td>{{ row.moduleName }}</td>
          <td class="text-center">{{ row.week }}</td>
          <td>{{ formatDate(row.learnedAt) }}</td>
        </tr>
      </tbody>
    </table>
  </b-modal>
</template>

<script>
export default {
  name: 'ModalLessonResultDetail',
  props: {
    item: {
      type: Object,
      default: null,
    },
    // Cùng khoảng thời gian hoàn thành đang lọc ở màn list
    dateFrom: {
      type: String,
      default: null,
    },
    dateTo: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      rows: [],
    };
  },
  computed: {
    phone() {
      const phone = this.item?.phoneNumber;
      return phone ? phone.replace('+84', '0') : null;
    },
  },
  methods: {
    async loadData() {
      if (!this.item?.accountId) return;

      this.loading = true;
      try {
        const { meta, data, error } = await this.$api.get('/Lesson/LessonResultDetail', {
          params: {
            accountId: this.item.accountId,
            dateFrom: this.dateFrom,
            dateTo: this.dateTo,
          },
        });
        if (!meta.success) {
          return this.$toastr.e({ title: 'Lỗi !', msg: error.message });
        }
        this.rows = data || [];
      } catch (error) {
        this.$toastr.e({ title: 'Lỗi !', msg: error.message });
      } finally {
        this.loading = false;
      }
    },
    // BE trả DateTime dạng unix timestamp (giây)
    formatDate(value) {
      return value ? this.convertTimestampToDate(value, 'DD/MM/YYYY HH:mm') : null;
    },
  },
};
</script>
